
<template>
    <div>
        <div class="col-lg-8" v-if="records && records.length > 0">
            <small class="font-weight-bold">
                Showing {{ pagination.from == 0 ? 1 : pagination.from }} - {{ pagination.to }} of
                {{ pagination.total }} entries
            </small>
        </div>

        <div
            class="card shadow"
            v-if="records && records.length > 0"
        >
            <div class="table-responsive">
                <base-table
                    class="table align-items-center table-flush"
                    thead-classes="thead-light"
                    tbody-classes="list"
                    :data="records"
                >
                    <template slot="columns">
                        <th width="2%">S/N</th>
                        <th width="15%">Doctor's Name</th>
                        <th width="10%">Practice Type</th>
                        <th width="10%">Gender</th>
                        <th width="10%">State of <br>Practice</th>
                        <th width="10%">LGA of <br>Practice</th>
                        <th width="10%">&nbsp;</th>
                    </template>

                    <template
                        slot-scope="{row, index}"
                    >
                        <td class="budget">
                            {{ pagination.from+index}}
                        </td>
                        <td class="text-capitalize">
                            {{ getFullName(row) }}<br>
                            <badge
                                size="sm" type="primary"
                                class="font-weight-bolder"
                            >
                                {{ row && row.folio_number ? row.folio_number : 'M/A' }}
                            </badge>
                        </td>
                        <td>
                            {{ getPracticeTypeName(row) }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.gender }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.has_practice_state ? row.has_practice_state.name : 'N/A' }}
                        </td>
                        <td class="text-capitalize">
                            {{ row.has_practice_lga ? row.has_practice_lga.name : 'N/A' }}
                        </td>
                        <td>
                            <button
                                class="btn btn-sm btn-danger"
                                @click="addToList(row.id)"
                                v-if="! row.on_exit_register"
                                :disabled="(privileges && privileges.add == 'no') || ! privileges"
                            >
                                <i class="fa fa-plus"></i>
                                Add To List
                            </button>

                            <badge
                                size="sm" type="danger"
                                class="font-weight-bolder"
                                v-if="row.on_exit_register"
                            >
                                Deceased
                            </badge>
                        </td>
                    </template>
                </base-table>
            </div>

            <div
                class="card-footer d-flex justify-content-end bg-transparent"
                v-if="hasPagination"
                    @click="paginate"
            >
                <base-pagination
                    :total="pagination.total"
                    align="center"
                    v-model="pagination.number"
                    :perPage="pagination.perPage"

                >
                </base-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'AddExitRegisterData',
        props: ['records', 'hasPagination', 'pagination', 'paginate', 'privileges', 'loadUsers'],
        methods: {
            ...mapActions(['addUserExitRegister']),
            getFullName(user) {// get full name
                if(user) {
                    let name = user.first_name+' ';
                    name += user.other_name ? user.other_name+' ' : '';
                    name += user.last_name+' ';
                    return name.toLowerCase();
                } else {
                    return 'N/A';
                }
            },
            getPracticeTypeName(data) {// get practice type name
                let type = data && data.get_doctor_type ? data.get_doctor_type : false;
                return (type && type.name) ? type.name : 'N/A';
            },
            addToList(id) {
                swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Proceed!'
                }).then((result) => {
                    if (result.value) {
                        this.makeAddApiCall(id);// make api call
                    }
                });
            },
            makeAddApiCall(id) {
                let data = { 'user_data_id' : id, 'admin_id' : this.$store.state.user.userId };
                this.preloader(); // show loading
                this.addUserExitRegister(data).then((res) => {// add user to sanction
                    if(res.status) {
                        this.loadUsers();// refresh page
                        swal.fire("User Added", res.msg, "success");
                    } else {
                        this.loadUsers();// refresh page
                        swal.fire("Error Occurred!", res.msg, "warning");
                    }
                }).
                catch(err => {
                    this.loadUsers();// refresh page
                    swal.fire(err.message+"!", "An error occurred while deleting, try again", "warning");
                });
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        }
    };
</script>
<style>
    .table td {
        font-size: 15px;
    }
</style>
